import { useContext } from 'react';

import { exitContext } from 'src/contexts/exit';

export function useExit() {
    const { exit } = useContext(exitContext);

    return exit;
}
